import { Alert, Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import type { ShiptimeShipmentResponse } from '@shipium-corp/shipium-ts-types';
import { ExecutionTrace } from './ExecutionTrace';
import type { ActiveRuleSummary } from './types';
import { buildProcessedTimeline } from './ruleTimeline';

export interface RuleTestResultsProps {
  response: ShiptimeShipmentResponse;
  onRunAgain: () => void;
  selectedMethodName: string;
  selectedCarrierName?: string;
  methodNameById: Record<string, string>;
  activeRulesInOrder: ActiveRuleSummary[];
}

export const RuleTestResults = ({
  response,
  onRunAgain,
  selectedMethodName,
  selectedCarrierName,
  methodNameById,
  activeRulesInOrder,
}: RuleTestResultsProps) => {
  const timeline = buildProcessedTimeline(response, activeRulesInOrder);
  // Without the carrier decision details there is nothing to trace; rendering the timeline anyway
  // would mark every rule "Does Not Apply" and show an empty pool, which reads as a wrong result.
  const hasTrace = Boolean(response.details?.carrierSelection?.carrierDecision?.details);

  return (
    <div>
      <Alert
        type="info"
        showIcon
        icon={<CheckCircleFilled />}
        style={{ marginBottom: 12 }}
        message={
          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
                color: 'rgba(0,0,0,0.65)',
                marginBottom: 2,
              }}
            >
              Carrier selected
            </div>
            <div style={{ fontSize: 14, fontWeight: 500 }}>{selectedMethodName}</div>
            {selectedCarrierName ? (
              <div style={{ fontSize: 12, color: 'rgba(0,0,0,0.55)' }}>{selectedCarrierName}</div>
            ) : null}
          </div>
        }
      />
      {hasTrace ? (
        <ExecutionTrace timeline={timeline} methodNameById={methodNameById} />
      ) : (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="The execution trace isn't available for this run. The carrier selected above is still the result of the test."
        />
      )}
      <Button type="primary" onClick={onRunAgain}>
        Back to form
      </Button>
    </div>
  );
};
